import { render, staticRenderFns } from "./Loss.vue?vue&type=template&id=2cc47e69&scoped=true&"
import script from "./Loss.vue?vue&type=script&lang=js&"
export * from "./Loss.vue?vue&type=script&lang=js&"
import style0 from "./Loss.vue?vue&type=style&index=0&id=2cc47e69&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc47e69",
  null
  
)

export default component.exports